import { LiveInspectorData } from "types/types";
import { PolyRefFunction } from "@wise-emotions/react-utils";
import React from "react";

const polyforwardRef = React.forwardRef as PolyRefFunction;

export const Poly = polyforwardRef<
  "div",
  { children: React.ReactNode; liveInspector?: LiveInspectorData }
>(({ as = "div", children, liveInspector, ...props }) => {
  const Component = as;
  return (
    <>
      <Component {...props} {...liveInspector?.poly}>
        {children}
      </Component>
      {"modalRender" in props && props.modalRender}
    </>
  );
});
